// extracted by mini-css-extract-plugin
export default {"avatarImage":"Avatar_avatarImage__noXFE","avatarFallback":"Avatar_avatarFallback__bEw6p"};